import React from 'react';
import { CandidateLogin } from './candidate-login.view';
import { CandidateLoginProvider } from './candidate-login.provider';

type CandidateLoginFeatureProps = {
   captchaKey: string | null;
};

export const CandidateLoginFeature = ({ captchaKey }: CandidateLoginFeatureProps) => {
   return (
      <CandidateLoginProvider>
         <CandidateLogin captchaKey={captchaKey}></CandidateLogin>
      </CandidateLoginProvider>
   );
};
